import { render } from "./TaskList.vue?vue&type=template&id=6856a7e4&scoped=true&ts=true"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"

import "./TaskList.vue?vue&type=style&index=0&id=6856a7e4&lang=scss"
import "./TaskList.vue?vue&type=style&index=1&id=6856a7e4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6856a7e4"]])

export default __exports__